import { render, staticRenderFns } from "./akcd_ref_overview.vue?vue&type=template&id=f85d1fa8&scoped=true"
import script from "./akcd_ref_overview.vue?vue&type=script&lang=js"
export * from "./akcd_ref_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d1fa8",
  null
  
)

export default component.exports